/** @jsx jsx */
import { Fragment } from 'react'
import { Box, jsx } from 'theme-ui'
import ReviewListPageHeading from './Heading/Page'
import ReviewListSectionFeaturedReviews from './FeaturedReviews'
import ReviewListSectionHeading from './Heading/Section'
import Reviews from '~/components/Reviews'

const ReviewListSection = ({
  bgOverride,
  description,
  media,
  subtitle,
  title,
  variant,
}) => {
  const featuredReviews = media.filter(
    ({ __typename }) => __typename === 'ContentfulQuote'
  )
  const featuredPack = media.find(
    ({ __typename }) => __typename === 'ContentfulPack'
  )

  return (
    <Box>
      {variant === 'page' && (
        <ReviewListPageHeading title={title} description={description} />
      )}
      {variant === 'section' && (
        <Fragment>
          <Box id="reviews" sx={{ position: 'relative', top: '-65px' }} />
          <ReviewListSectionHeading
            bgOverride={bgOverride}
            subtitle={subtitle}
            title={title}
          />
        </Fragment>
      )}
      <ReviewListSectionFeaturedReviews reviews={featuredReviews} />
      <Reviews
        hideTitle={true}
        id={featuredPack && featuredPack?.slug}
        title="All Reviews"
      />
    </Box>
  )
}

export default ReviewListSection
